import { forwardRef, useEffect, useRef, useState } from "react";
import {
  selectDitaPath,
  selectTocId,
  setGuideline,
} from "../counter/counterSlice";
import useAppModernisation from "../../hooks/useAppModernisation";
import classNames from "classnames";
import AcknowledgementModal from "../../components/AcknowledgementModal/acknowledgementModal";
import PdfModal from "../../components/pdfModal";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { EnhancedCounter } from "../../components/EnhancedCounter/EnhancedCounter";
import Counter from "../counter/Counter";
import Version from "../counter/Version";

const ModernMainContent = forwardRef(({}, ref) => {
  const { pathname, search } = useLocation();
  const [displayGuideline, setDisplayGuideline] = useState(false);
  const [referencePopup, setReferencePopup] = useState("");
  const dispatch = useDispatch();
  const tocId = useSelector(selectTocId);
  const refInfo = useRef(null);
  const { isMobileView, isEnhancedCounter } = useAppModernisation();

  useEffect(() => {
    console.log("dispatch setGuideline", search);
    dispatch(setGuideline({ search: search }));
    if (search.indexOf("topicfile") === -1) {
      console.log("setDisplayGuideline");
      setDisplayGuideline(true);
    }
  }, [search, dispatch]);

  const treeMenuClass = classNames("d-none");

  const ditapath = useSelector(selectDitaPath);
  return (
    <div ref={ref}>
      <AcknowledgementModal />
      <PdfModal />

      <div className={"topicMainContent"}>
        <div
          className={classNames({
            appMode: isMobileView,
          })}
        >
          <div className="sectionBlockLayout">
            <div className="dart-container">
              <div className="maincontent">
                <noscript>
                  You need to enable JavaScript to run this app.
                </noscript>
                <div
                  className={`columnBlockLayout ${treeMenuClass}`}
                  id="tocId"
                >
                  <div id="tocbox">
                    <a id="tocID" dangerouslySetInnerHTML={{ __html: tocId }} />
                    <div id="TOC_ID">
                      {ditapath && (
                        <div id="tg_toc_id">
                          <div
                            className="dartframe fa fa-compress"
                            onClick={() => {
                              document
                                .querySelectorAll("#TOC_ID, #contentId")
                                .forEach((el) => el.classList.toggle("active"));
                            }}
                          ></div>
                          <Version />
                          {isEnhancedCounter ? (
                            <EnhancedCounter
                              pathname={pathname}
                              search={search}
                              setReferencePopup={setReferencePopup}
                              forwardedRef={refInfo}
                            />
                          ) : (
                            <Counter
                              pathname={pathname}
                              search={search}
                              setReferencePopup={setReferencePopup}
                              ref={refInfo}
                            />
                          )}
                          <span className="username"></span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div
                  className={classNames("columnBlockLayout")}
                  id="etgcontent"
                >
                  <div id="contentId">
                    {referencePopup}
                    <div className="bodyContentDiv">
                      <section id="sectionContent"></section>
                    </div>
                  </div>
                  <div className="reader-list">
                    <div id="etgGuidelineBox">
                      {displayGuideline && (
                        <div className="topiclist noLeftPaddingXs noRightPaddingXs boxstrnth">
                          <div className="guideline-box mar-t32"></div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default ModernMainContent;
